
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/roadside-assistance",
      function () {
        return require("private-next-pages/roadside-assistance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/roadside-assistance"])
      });
    }
  